/**
 * Paid leave (employee cash leave) policy — 2 days per employee per calendar month.
 */
import {
  buildEmployeeCashLeaveYmdByEmployee,
  employeeCashLeaveYmdSet,
} from "../helpers/payrollAttendanceCore";

export const MONTHLY_PAID_LEAVE_ALLOWANCE = 2;

export function paidLeaveRemaining(usedCount) {
  return Math.max(0, MONTHLY_PAID_LEAVE_ALLOWANCE - (Number(usedCount) || 0));
}

export function paidLeaveOverAllowance(usedCount) {
  return Math.max(0, (Number(usedCount) || 0) - MONTHLY_PAID_LEAVE_ALLOWANCE);
}

function ymdLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Unique paid-leave dates for one employee in a calendar month. */
export function countEmployeePaidLeaveDaysInMonth(holidayDocSnaps, employeeId, calendarYear, monthIndex) {
  const monthStart = new Date(calendarYear, monthIndex, 1);
  const monthEnd = new Date(calendarYear, monthIndex + 1, 0);
  const byEmp = buildEmployeeCashLeaveYmdByEmployee(holidayDocSnaps || [], monthStart, monthEnd);
  return employeeCashLeaveYmdSet(byEmp, employeeId).size;
}

/**
 * Employees who would exceed the monthly allowance if a new cash-leave date is added.
 * @returns {{ employeeId: string, used: number, allowance: number }[]}
 */
export function employeesBlockedFromPaidLeave(holidayDocSnaps, employeeIds, dateOnly) {
  if (!dateOnly || !Array.isArray(employeeIds) || !employeeIds.length) return [];

  const year = dateOnly.getFullYear();
  const monthIndex = dateOnly.getMonth();
  const dateStr = ymdLocal(dateOnly);
  const monthStart = new Date(year, monthIndex, 1);
  const monthEnd = new Date(year, monthIndex + 1, 0);
  const byEmp = buildEmployeeCashLeaveYmdByEmployee(holidayDocSnaps || [], monthStart, monthEnd);

  const blocked = [];
  const seen = new Set();
  for (const raw of employeeIds) {
    const employeeId = String(raw || "").trim();
    if (!employeeId) continue;
    const key = employeeId.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);

    const dates = employeeCashLeaveYmdSet(byEmp, employeeId);
    if (dates.has(dateStr)) continue;
    if (dates.size >= MONTHLY_PAID_LEAVE_ALLOWANCE) {
      blocked.push({
        employeeId,
        used: dates.size,
        allowance: MONTHLY_PAID_LEAVE_ALLOWANCE,
      });
    }
  }
  return blocked;
}

export function formatPaidLeaveBalance(usedCount) {
  const used = Number(usedCount) || 0;
  return `${used} / ${MONTHLY_PAID_LEAVE_ALLOWANCE}`;
}
